export const EXCLUDE_TEST_ACCOUNTS = [
  '@combotag.com',
  '@cheq.ai',
  'test',
  'cheqtest',
  'seffykotz',
  'n.frishman',
  'jesseyuter',
] as const

export const isExcludedEmail = (email: string) => {
  const regex = new RegExp(EXCLUDE_TEST_ACCOUNTS.join('|'))
  return regex.test(email)
}
